// eslint-disable-next-line no-restricted-exports
export { default } from './Input';
export * from './Input';
